/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "вчера",
        "-2": "онзи ден",
        "0": "днес",
        "1": "утре",
        "2": "вдругиден",
        "future": {
          "one": "след {0} ден",
          "other": "след {0} дни"
        },
        "past": {
          "one": "преди {0} ден",
          "other": "преди {0} дни"
        }
      },
      "day-narrow": {
        "-1": "вчера",
        "-2": "онзи ден",
        "0": "днес",
        "1": "утре",
        "2": "вдругиден",
        "future": {
          "one": "сл. {0} д",
          "other": "сл. {0} д"
        },
        "past": {
          "one": "пр. {0} д",
          "other": "пр. {0} д"
        }
      },
      "day-short": {
        "-1": "вчера",
        "-2": "онзи ден",
        "0": "днес",
        "1": "утре",
        "2": "вдругиден",
        "future": {
          "one": "след {0} ден",
          "other": "след {0} дни"
        },
        "past": {
          "one": "преди {0} ден",
          "other": "преди {0} дни"
        }
      },
      "hour": {
        "0": "в този час",
        "future": {
          "one": "след {0} час",
          "other": "след {0} часа"
        },
        "past": {
          "one": "преди {0} час",
          "other": "преди {0} часа"
        }
      },
      "hour-narrow": {
        "0": "в този час",
        "future": {
          "one": "сл. {0} ч",
          "other": "сл. {0} ч"
        },
        "past": {
          "one": "пр. {0} ч",
          "other": "пр. {0} ч"
        }
      },
      "hour-short": {
        "0": "в този час",
        "future": {
          "one": "след {0} ч",
          "other": "след {0} ч"
        },
        "past": {
          "one": "преди {0} ч",
          "other": "преди {0} ч"
        }
      },
      "minute": {
        "0": "в тази минута",
        "future": {
          "one": "след {0} минута",
          "other": "след {0} минути"
        },
        "past": {
          "one": "преди {0} минута",
          "other": "преди {0} минути"
        }
      },
      "minute-narrow": {
        "0": "в тази минута",
        "future": {
          "one": "сл. {0} мин",
          "other": "сл. {0} мин"
        },
        "past": {
          "one": "пр. {0} мин",
          "other": "пр. {0} мин"
        }
      },
      "minute-short": {
        "0": "в тази минута",
        "future": {
          "one": "след {0} мин",
          "other": "след {0} мин"
        },
        "past": {
          "one": "преди {0} мин",
          "other": "преди {0} мин"
        }
      },
      "month": {
        "-1": "предходен месец",
        "0": "този месец",
        "1": "следващ месец",
        "future": {
          "one": "след {0} месец",
          "other": "след {0} месеца"
        },
        "past": {
          "one": "преди {0} месец",
          "other": "преди {0} месеца"
        }
      },
      "month-narrow": {
        "-1": "мин. м.",
        "0": "т. м.",
        "1": "сл. м.",
        "future": {
          "one": "сл. {0} м.",
          "other": "сл. {0} м."
        },
        "past": {
          "one": "пр. {0} м.",
          "other": "пр. {0} м."
        }
      },
      "month-short": {
        "-1": "мин. мес.",
        "0": "този мес.",
        "1": "следв. мес.",
        "future": {
          "one": "след {0} м.",
          "other": "след {0} м."
        },
        "past": {
          "one": "преди {0} м.",
          "other": "преди {0} м."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "предходно тримесечие",
        "0": "това тримесечие",
        "1": "следващо тримесечие",
        "future": {
          "one": "след {0} тримесечие",
          "other": "след {0} тримесечия"
        },
        "past": {
          "one": "преди {0} тримесечие",
          "other": "преди {0} тримесечия"
        }
      },
      "quarter-narrow": {
        "-1": "мин. трим.",
        "0": "това трим.",
        "1": "следв. трим.",
        "future": {
          "one": "сл. {0} трим.",
          "other": "сл. {0} трим."
        },
        "past": {
          "one": "пр. {0} трим.",
          "other": "пр. {0} трим."
        }
      },
      "quarter-short": {
        "-1": "мин. трим.",
        "0": "това трим.",
        "1": "следв. трим.",
        "future": {
          "one": "след {0} трим.",
          "other": "след {0} трим."
        },
        "past": {
          "one": "преди {0} трим.",
          "other": "преди {0} трим."
        }
      },
      "second": {
        "0": "сега",
        "future": {
          "one": "след {0} секунда",
          "other": "след {0} секунди"
        },
        "past": {
          "one": "преди {0} секунда",
          "other": "преди {0} секунди"
        }
      },
      "second-narrow": {
        "0": "сега",
        "future": {
          "one": "сл. {0} сек",
          "other": "сл. {0} сек"
        },
        "past": {
          "one": "пр. {0} сек",
          "other": "пр. {0} сек"
        }
      },
      "second-short": {
        "0": "сега",
        "future": {
          "one": "след {0} сек",
          "other": "след {0} сек"
        },
        "past": {
          "one": "преди {0} сек",
          "other": "преди {0} сек"
        }
      },
      "week": {
        "-1": "предходната седмица",
        "0": "тази седмица",
        "1": "следващата седмица",
        "future": {
          "one": "след {0} седмица",
          "other": "след {0} седмици"
        },
        "past": {
          "one": "преди {0} седмица",
          "other": "преди {0} седмици"
        }
      },
      "week-narrow": {
        "-1": "мин. седм.",
        "0": "тази седм.",
        "1": "сл. седм.",
        "future": {
          "one": "сл. {0} седм.",
          "other": "сл. {0} седм."
        },
        "past": {
          "one": "пр. {0} седм.",
          "other": "пр. {0} седм."
        }
      },
      "week-short": {
        "-1": "мин. седм.",
        "0": "тази седм.",
        "1": "следв. седм.",
        "future": {
          "one": "след {0} седм.",
          "other": "след {0} седм."
        },
        "past": {
          "one": "преди {0} седм.",
          "other": "преди {0} седм."
        }
      },
      "year": {
        "-1": "миналата година",
        "0": "тази година",
        "1": "следващата година",
        "future": {
          "one": "след {0} година",
          "other": "след {0} години"
        },
        "past": {
          "one": "преди {0} година",
          "other": "преди {0} години"
        }
      },
      "year-narrow": {
        "-1": "мин. г.",
        "0": "т. г.",
        "1": "сл. г.",
        "future": {
          "one": "сл. {0} г.",
          "other": "сл. {0} г."
        },
        "past": {
          "one": "пр. {0} г.",
          "other": "пр. {0} г."
        }
      },
      "year-short": {
        "-1": "мин. г.",
        "0": "т. г.",
        "1": "следв. г.",
        "future": {
          "one": "след {0} г.",
          "other": "след {0} г."
        },
        "past": {
          "one": "преди {0} г.",
          "other": "преди {0} г."
        }
      }
    },
    "locale": "bg"
  });
}